import {Rule} from '../../models/svg-rule/rule.model';
import {IRuleSystem} from '../../models/svg-rule/rule-system.model';
import {Color} from '../../enums/color';
import {TcddTrainTabUtil, ValueIndex} from '../../utils/tcdd-train-tab-util';
import {TcddMainSystem} from '../../enums/tcdd-main-system.enum';
import {TcddSubSystem} from '../../enums/tcdd-sub-system.enum';
import {TcddSubSystemType} from '../../enums/tcdd-sub-system-type.enum';
import {PowerVoltageSystemKeys} from '../../constants/tcdd-system-keys/power-voltage-system-keys';
import {POWER_VOLTAGE_SYSTEM} from '../../constants/tcdd-system-contants/power-voltage-system.constant';
import {TCDD_UNIT} from '../../constants/tcdd-unit-constant';
import {createColorRule} from '../../utils/tcdd-rule-util';

function getIndex(key: string): ValueIndex {
  return TcddTrainTabUtil.getValueIndex(
    TcddMainSystem.DIAGNOSTIC_SYSTEM,
    TcddSubSystem.POWER_VOLTAGE_SYSTEM,
    TcddSubSystemType.SUB,
    key
  );
}

export class PowerVoltageSystemRules implements IRuleSystem {
  public getRules(): Rule[] {
    return [
      createColorRule(TCDD_UNIT.PANTOGRAPH_UP, (wagonIndex: number, data: any[], setColor: (color: Color) => void) => {
        const wagonData = data?.[TcddSubSystem.POWER_VOLTAGE_SYSTEM]?.[wagonIndex];
        if (!wagonData) return false;

        const pressurePs1SafeguardAdd: ValueIndex = getIndex(PowerVoltageSystemKeys.pressurePs1SafeguardAdd);
        const isPantographDown = Number(wagonData[pressurePs1SafeguardAdd.groupIndex]?.[pressurePs1SafeguardAdd.infoIndex]) === POWER_VOLTAGE_SYSTEM.STATUS.PANTOGRAPH_DOWN;

        if (isPantographDown) {
          setColor(Color.Transparent);
        }

        return isPantographDown;
      }),
      createColorRule(TCDD_UNIT.PANTOGRAPH_DOWN, (wagonIndex: number, data: any[], setColor: (color: Color) => void) => {
        const wagonData = data?.[TcddSubSystem.POWER_VOLTAGE_SYSTEM]?.[wagonIndex];
        if (!wagonData) return false;

        const pressurePs1SafeguardAdd: ValueIndex = getIndex(PowerVoltageSystemKeys.pressurePs1SafeguardAdd);
        const isPantographUp = Number(wagonData[pressurePs1SafeguardAdd.groupIndex]?.[pressurePs1SafeguardAdd.infoIndex]) === POWER_VOLTAGE_SYSTEM.STATUS.PANTOGRAPH_UP;

        if (isPantographUp) {
          setColor(Color.Transparent);
        }

        return isPantographUp;
      }),
      createColorRule(TCDD_UNIT.TRANSFORMER, (wagonIndex: number, data: any[], setColor: (color: Color) => void) => {
        const wagonData = data?.[TcddSubSystem.POWER_VOLTAGE_SYSTEM]?.[wagonIndex];
        if (!wagonData) return false;

        const tractionTransformerTemperatureTcu: ValueIndex = getIndex(PowerVoltageSystemKeys.tractionTransformerTemperatureTcu); // >75 will be red, <65 will be gray

        if (Number(wagonData[tractionTransformerTemperatureTcu.groupIndex]?.[tractionTransformerTemperatureTcu.infoIndex]) > POWER_VOLTAGE_SYSTEM.TRANSFORMER_TCU_RED_THRESHOLD) { // Red state
          setColor(Color.Red);
          return true;
        }

        if (Number(wagonData[tractionTransformerTemperatureTcu.groupIndex]?.[tractionTransformerTemperatureTcu.infoIndex]) < POWER_VOLTAGE_SYSTEM.TRANSFORMER_TCU_GRAY_THRESHOLD) { // Gray state
          setColor(Color.Gray);
          return true;
        }

        return false;
      }),
      createColorRule(TCDD_UNIT.BATTERY, (wagonIndex: number, data: any[], setColor: (color: Color) => void) => {
        const wagonData = data?.[TcddSubSystem.POWER_VOLTAGE_SYSTEM]?.[wagonIndex];
        if (!wagonData) return false;

        const sBatteryChar: ValueIndex = getIndex(PowerVoltageSystemKeys.sBatteryChar); // === 0 will be red
        const measuringBatteryVoltage: ValueIndex = getIndex(PowerVoltageSystemKeys.measuringBatteryVoltage); // <90 will be red, >100 will be gray
        const tempBattery: ValueIndex = getIndex(PowerVoltageSystemKeys.tempBattery); // >40 will be red, <30 will be gray

        if (// Red state
          Number(wagonData[sBatteryChar.groupIndex]?.[sBatteryChar.infoIndex]) === POWER_VOLTAGE_SYSTEM.STATUS.BATTERY_CHAR_ERROR ||
          Number(wagonData[measuringBatteryVoltage.groupIndex]?.[measuringBatteryVoltage.infoIndex]) < POWER_VOLTAGE_SYSTEM.BATTERY_VOLTAGE_RED_THRESHOLD ||
          Number(wagonData[tempBattery.groupIndex]?.[tempBattery.infoIndex]) > POWER_VOLTAGE_SYSTEM.BATTERY_TEMP_RED_THRESHOLD) {
          setColor(Color.Red);
          return true;
        }

        if (// Gray state
          Number(wagonData[measuringBatteryVoltage.groupIndex]?.[measuringBatteryVoltage.infoIndex]) > POWER_VOLTAGE_SYSTEM.BATTERY_VOLTAGE_GRAY_THRESHOLD ||
          Number(wagonData[tempBattery.groupIndex]?.[tempBattery.infoIndex]) < POWER_VOLTAGE_SYSTEM.BATTERY_TEMP_GRAY_THRESHOLD) {
          setColor(Color.Gray);
          return true;
        }

        return false;
      }),
    ];
  }
}
